customElements.get("product-form") || customElements.define("product-form", class t extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    this.formIdInput = this.form.querySelector("[name=id]");
    this.formIdInput.disabled = false;

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.submitButton = this.querySelector('[type="submit"]');
    this.stickyAtcButton = document.getElementById(`StickyAtcSubmitButton-${this.dataset.section}`);

    if (document.querySelector("cart-drawer")) {
      this.submitButton.setAttribute("aria-haspopup", "dialog");
    }

    this.bundleDeals = document.getElementById(`bundle-deals-${this.dataset.section}`);
    this.quantityBreaks = document.getElementById(`quantity-breaks-${this.dataset.section}`);
    this.customFields = document.querySelectorAll(`[id^='CustomField-${this.dataset.section}-']`);
    this.variantInputs = this.form.querySelector(".product-form__variants");

    // Hide the bundle and save section on the Full Set page
    if (window.location.pathname.includes('/products/full-set')) {
      console.log('Hiding Bundle and Save section for Full Set page.');
      if (this.bundleDeals) this.bundleDeals.style.display = 'none';
      if (this.quantityBreaks) this.quantityBreaks.style.display = 'none';
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.handleErrorMessage();
    this.submitButton.setAttribute("aria-disabled", "true");
    this.submitButton.classList.add("loading");
    this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

    if (this.stickyAtcButton) {
      this.stickyAtcButton.classList.add("loading");
      this.stickyAtcButton.querySelector(".loading-overlay__spinner").classList.remove("hidden");
    }

    let customData = false;

    if (this.variantInputs) {
      this.variantInputs.innerHTML = "";
    }

    if (this.bundleDeals) {
      let inputHtml = "";
      customData = true;

      for (let i = 0; i < this.bundleDeals.formVariants.length; i++) {
        let variant = this.bundleDeals.formVariants[i];
        inputHtml += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`
        inputHtml += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
      }
      this.variantInputs.innerHTML = inputHtml;
    } else if (this.quantityBreaks && this.variantInputs && this.quantityBreaks.formVariants.length > 0) {
      let inputHtml = "";
      customData = true;

      for (let i = 0; i < this.quantityBreaks.formVariants.length; i++) {
        let variant = this.quantityBreaks.formVariants[i];
        inputHtml += `<input type="hidden" name="items[${i}][quantity]" value="${variant.quantity}">`;
        inputHtml += `<input type="hidden" name="items[${i}][id]" value="${variant.id}">`;
        this.customFields.forEach(field => {
          inputHtml += `<input type="hidden" name="items[${i}][properties][${field.fieldName}]" value="${field.value}">`;
        });
      }
      this.variantInputs.innerHTML = inputHtml;
    }

    let config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    delete config.headers["Content-Type"];

    let formData = new FormData(this.form);

    if (this.cart) {
      formData.append("sections", this.cart.getSectionsToRender().map(section => section.id));
      formData.append("sections_url", window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    if (customData) {
      let options = this.dataset.options ? this.dataset.options.split(",") : [];
      let keys = ["id", "quantity", ...options];
      for (let key of keys) {
        formData.delete(key);
      }
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          let soldOutMessage = this.submitButton.querySelector(".sold-out-message");

          if (!soldOutMessage) return;
          this.submitButton.setAttribute("aria-disabled", "true");
          this.submitButton.querySelector("span").classList.add("hidden");
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        }

        if (this.skipCart) {
          window.location = "/checkout";
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        this.error || publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
        this.error = false;

        let quickAddModal = this.closest("quick-add-modal");
        if (quickAddModal) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => { this.cart.renderContents(response); }, 0);
          }, { once: true });
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      })
      .catch(error => console.error(error))
      .finally(() => {
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner").classList.add("hidden");

        if (this.stickyAtcButton) {
          this.stickyAtcButton.classList.remove("loading");
          this.stickyAtcButton.querySelector(".loading-overlay__spinner").classList.add("hidden");
        }

        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        this.error || this.submitButton.removeAttribute("aria-disabled");
      });
  }

  handleErrorMessage(message = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (this.errorMessageWrapper) {
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !message);
      if (message) this.errorMessage.textContent = message;
    }
  }
});